export const transformApiPlansToCardFormat = (
  apiPlans,
  userTimezone = "UTC",
) => {
  const planSubHeaders = {
    starter: "Perfect for small teams getting started",
    professional: "Ideal for growing recruitment teams",
    enterprise: "For large organizations with specific needs",
  };

  const getCountryFromTimezone = (timezone) => {
    const timezoneToCurrency = {
      "America/New_York": "USD",
      "America/Los_Angeles": "USD",
      "America/Chicago": "USD",
      "America/Toronto": "CAD",
      "America/Vancouver": "CAD",
      "Europe/London": "GBP",
      "Europe/Paris": "EUR",
      "Europe/Berlin": "EUR",
      "Europe/Moscow": "RUB",
      "Asia/Kolkata": "INR",
      "Asia/Calcutta": "INR",
      "Asia/Tokyo": "JPY",
      "Asia/Shanghai": "CNY",
      "Asia/Singapore": "SGD",
      "Australia/Sydney": "AUD",
      "Pacific/Auckland": "NZD",
    };
    if (timezoneToCurrency[timezone]) {
      return timezoneToCurrency[timezone];
    }
    const countryMatch = timezone.match(/\/([^\/]+)$/);
    if (countryMatch) {
      const location = countryMatch[1];
      const locationToCurrency = {
        New_York: "USD",
        Los_Angeles: "USD",
        Chicago: "USD",
        Toronto: "CAD",
        Vancouver: "CAD",
        London: "GBP",
        Paris: "EUR",
        Berlin: "EUR",
        Moscow: "RUB",
        Kolkata: "INR",
        Tokyo: "JPY",
        Shanghai: "CNY",
        Singapore: "SGD",
        Sydney: "AUD",
        Auckland: "NZD",
      };

      if (locationToCurrency[location]) {
        return locationToCurrency[location];
      }
    }
    return "USD";
  };

  const getPreferredCurrency = (timezone) => {
    const userCurrency = getCountryFromTimezone(timezone);
    const availableCurrencies = ["USD", "CAD", "INR"];
    if (availableCurrencies.includes(userCurrency)) {
      return userCurrency;
    }
    if (
      timezone.includes("America/New_York") ||
      timezone.includes("America/Los_Angeles") ||
      timezone.includes("America/Chicago")
    ) {
      return "USD";
    } else if (
      timezone.includes("America/Toronto") ||
      timezone.includes("America/Vancouver")
    ) {
      return "CAD";
    } else if (timezone.includes("Asia/Kolkata")) {
      return "INR";
    }

    return "USD";
  };

  const formatCurrency = (amount, currency) => {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formatter.format(amount / 100);
  };

  const formatFeature = (feature) => {
    if (feature.name === "max_users") {
      return `Up to ${feature.value} users`;
    }
    return `${feature.name}: ${feature.value}`;
  };

  const preferredCurrency = getPreferredCurrency(userTimezone);

  return apiPlans.map((plan) => {
    const planName = plan.name.toLowerCase();
    const preferredPrice = plan.prices.find(
      (price) => price.currency === preferredCurrency,
    );
    const usdPrice = plan.prices.find((price) => price.currency === "USD");
    const defaultPrice = preferredPrice || usdPrice || plan.prices[0];

    const staticFeatures = [
      "Unlimited resume parser credits",
      "AI Candidate Search",
      "AI Job Matcher",
      "Candidate management",
      "Job pipeline management",
      "Interview scheduling",
      "Email Campaigns",
      "Job Posting",
    ];

    const apiFeatures = plan.features.map(formatFeature);
    const maxUserFeature = apiFeatures.find((feature) =>
      feature.startsWith("Up to"),
    );

    let allFeatures = [...staticFeatures];
    if (maxUserFeature) {
      allFeatures = [maxUserFeature, ...allFeatures];
    }

    if (planName === "enterprise") {
      allFeatures = [
        ...allFeatures,
        "Vendor management",
        "3rd-party API integration",
      ];
    }

    return {
      id: plan.id.trim(),
      name: plan.name.charAt(0).toUpperCase() + plan.name.slice(1),
      subHeader: planSubHeaders[planName] || "Perfect for growing teams",
      price: `${formatCurrency(defaultPrice.price_amount, defaultPrice.currency)} /${defaultPrice.billing_interval}`,
      features: allFeatures,
      buttonText: "Start Plan",
      trialButtonText: "Free Trial",
      highlighted: false,
      apiData: plan,
      currency: defaultPrice.currency,
    };
  });
};
